import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=b8cfd68c&scoped=true&"
import script from "./CreateProfile.vue?vue&type=script&lang=js&"
export * from "./CreateProfile.vue?vue&type=script&lang=js&"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=b8cfd68c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8cfd68c",
  null
  
)

export default component.exports